import Alert from '@mui/material/Alert';

export default function StepFiles() {
  return <Alert severity='info'>Project Files & Documents Section coming soon!</Alert>;
}
